import React from 'react';
import { useTranslation } from 'react-i18next';

import { LabSampleType } from 'store/labSamples/types';
import { PORTAL_SAMPLE_TYPE } from 'store/samples/types';
import { Banner } from 'common';

type PriorityPropsType = {
  sample: LabSampleType;
};

export const PortalSample = ({ sample }: PriorityPropsType) => {
  const { t } = useTranslation();
  return (
    <>{sample.type === PORTAL_SAMPLE_TYPE && <Banner headingText={t('portalSampleType')} />}</>
  );
};
